define.alias("ember-useragent/helpers/user-agent", "preview-grid/helpers/user-agent");